module.exports = __webpack_public_path__ + "static/media/main idea.60cf9831.mp3";